/** @file Default decimal places of a numeric field: enough to show one fine (shift) scrub step exactly. */
import { fineFactor } from './fineFactor';

/** Upper limit of the derived precision, also the search bound. */
const MAX_PRECISION = 10;

/** Relative slack that absorbs binary noise such as 0.1 * 0.1 = 0.010000000000000002. */
const TOLERANCE = 1e-9;

/** Decimals of `step * fineFactor` (steps 1, 0.1, 0.25 and 0.01 give 1, 2, 3 and 3); 0 for a step that is not a positive finite number. */
export function stepPrecision(step: number): number {
  const fine = step * fineFactor;
  if (!Number.isFinite(fine) || fine <= 0) return 0;
  for (let places = 0; places < MAX_PRECISION; places += 1) {
    if (Math.abs(fine - Number(fine.toFixed(places))) <= fine * TOLERANCE) return places;
  }
  return MAX_PRECISION;
}
